// extracted by mini-css-extract-plugin
export default {"newDropdownSelectList":"NewDropdownSelectList_newDropdownSelectList__8Agu-","newDropdownMenuItem":"NewDropdownSelectList_newDropdownMenuItem__zev9Z"};